// convert millis to human readable format
export const convertMilliseconds = (ms: number) => {
  if (!ms) return "";
  // Convert to seconds
  const seconds = ms / 1000;

  // Convert to minutes
  const minutes = seconds / 60;

  // Convert to hours
  const hours = minutes / 60;

  // Convert to days
  const days = hours / 24; 

  // Choose the appropriate unit based on magnitude
  if (days >= 1) {
    return `${days.toFixed(2)} days`;
  }
  if (hours >= 1) {
    return `${hours.toFixed(2)} hours`;
  }
  if (minutes >= 1) {
    return `${minutes.toFixed(2)} minutes`;
  }
  if (seconds >= 1) {
    return `${seconds.toFixed(2)} seconds`;
  } 
  return `${ms} milliseconds`;
  
};

export const formatType = "standard";